import React, { useState } from 'react';
import {
  ArrowLeft,
  Building2,
  Home,
  KeyRound,
  Store,
  Layers,
  HardHat,
  MessageSquare,
  FileSearch,
  FileCheck,
  Users,
  Repeat,
  ChevronDown,
} from 'lucide-react';
import { Button } from '../ui/button';

const objektarten = [
  {
    icon: Building2,
    title: 'WEG-Verwaltung',
    description:
      'Professionelle Verwaltung von Wohnungseigentümergemeinschaften nach WEG – von der Eigentümerversammlung über die Jahresabrechnung bis zur Umsetzung von Beschlüssen.',
  },
  {
    icon: Home,
    title: 'Mietshäuser / Zinshäuser',
    description:
      'Vollständige Mietverwaltung: Mietverträge, Nebenkostenabrechnung, Mietanpassungen, Kommunikation mit Mietern und laufende Instandhaltung.',
  },
  {
    icon: KeyRound,
    title: 'Sondereigentumsverwaltung (SEV)',
    description:
      'Individuelle Betreuung einzelner Eigentumswohnungen – Vermietung, Abrechnung und Kontakt zum Mieter im Auftrag des Eigentümers.',
  },
  {
    icon: Store,
    title: 'Gewerbeobjekte',
    description:
      'Verwaltung von Gewerbeimmobilien mit allen Besonderheiten: individuelle Mietverträge, Umlagefähigkeit und Kommunikation mit gewerblichen Mietern.',
  },
  {
    icon: Layers,
    title: 'Gemischt genutzte Immobilien',
    description:
      'Objekte mit Wohn- und Gewerbeeinheiten – wir behalten den Überblick und rechnen sauber nach den jeweiligen Vorgaben ab.',
  },
  {
    icon: HardHat,
    title: 'Neubau- & Erstverwaltung',
    description:
      'Begleitung von Neubauprojekten ab der Übergabe – inklusive Erstellung der Gemeinschaftsordnung, Erstabrechnungen und Aufbau der Verwaltungsstrukturen.',
  },
];

const ablaufSchritte = [
  {
    icon: MessageSquare,
    title: 'Erstgespräch & Bedarfsanalyse',
    description:
      'Wir lernen uns kennen, besprechen Ihre Immobilie, Ihre Erwartungen und die aktuelle Situation – unverbindlich und kostenfrei.',
  },
  {
    icon: FileSearch,
    title: 'Unterlagenprüfung & Angebot',
    description:
      'Wir sichten bestehende Verträge, Abrechnungen und Beschlüsse und erstellen Ihnen ein transparentes, individuelles Angebot.',
  },
  {
    icon: FileCheck,
    title: 'Verwaltervertrag & Übernahme',
    description:
      'Nach Unterzeichnung des Verwaltervertrags übernehmen wir alle Unterlagen, Konten und Schlüssel vom bisherigen Verwalter.',
  },
  {
    icon: Users,
    title: 'Erste Eigentümerversammlung',
    description:
      'Wir stellen uns persönlich vor, präsentieren den Status Ihrer Immobilie und stimmen die nächsten Schritte gemeinsam ab.',
  },
  {
    icon: Repeat,
    title: 'Laufende Verwaltung',
    description:
      'Ab jetzt kümmern wir uns um alles Weitere – von der Buchhaltung über Instandhaltung bis zur jährlichen Abrechnung.',
  },
];

const faqs = [
  {
    frage: 'Was kostet eine professionelle Hausverwaltung?',
    antwort:
      'Die Verwaltungsgebühr richtet sich nach Art des Objekts, Anzahl der Einheiten und dem Leistungsumfang. In der WEG-Verwaltung ist ein monatlicher Pauschalpreis pro Einheit üblich. Wir erstellen Ihnen nach einem Erstgespräch ein individuelles, transparentes Angebot – ohne versteckte Kosten.',
  },
  {
    frage: 'Wie wechseln wir den Verwalter? Geht das einfach?',
    antwort:
      'Ein Verwalterwechsel ist in der Regel unkompliziert. Voraussetzung ist ein entsprechender Beschluss in der Eigentümerversammlung (WEG) bzw. eine Kündigung des bestehenden Vertrags. Wir unterstützen Sie bei allen Schritten – von der Beschlussvorlage bis zur vollständigen Übernahme aller Unterlagen.',
  },
  {
    frage: 'Welche Unterlagen benötigen Sie für die Übernahme?',
    antwort:
      'Typischerweise benötigen wir den bestehenden Verwaltervertrag, die aktuelle Teilungserklärung, Eigentümer- und Mieterlisten, die letzten Jahresabrechnungen, Wirtschaftspläne, Versammlungsprotokolle sowie Unterlagen zu Bankkonten und laufenden Verträgen (z.B. Versicherungen, Dienstleister).',
  },
  {
    frage: 'Wie oft findet eine Eigentümerversammlung statt?',
    antwort:
      'Gesetzlich ist mindestens eine ordentliche Eigentümerversammlung pro Jahr vorgeschrieben. Zusätzliche außerordentliche Versammlungen sind möglich, wenn wichtige Beschlüsse anstehen. Wir übernehmen Einladung, Moderation, Protokoll und die Umsetzung der Beschlüsse.',
  },
  {
    frage: 'Sind Sie auch außerhalb der Geschäftszeiten erreichbar?',
    antwort:
      'Für dringende Fälle – insbesondere Havarien wie Wasserschäden oder Heizungsausfälle – stehen wir unseren Objekten auch außerhalb der regulären Geschäftszeiten zur Verfügung. Unsere Eigentümer und Beiräte erhalten hierfür eine direkte Ansprechmöglichkeit.',
  },
  {
    frage: 'Übernehmen Sie auch kleine Objekte mit wenigen Einheiten?',
    antwort:
      'Ja. Wir verwalten Objekte unterschiedlichster Größe – vom Zweifamilienhaus bis zur größeren Wohnanlage. Gerade kleine Gemeinschaften profitieren oft besonders von einer persönlichen, zuverlässigen Verwaltung.',
  },
  {
    frage: 'Wie läuft die jährliche Abrechnung ab?',
    antwort:
      'Wir erstellen nach Ablauf des Wirtschaftsjahres eine nachvollziehbare Jahresabrechnung mit Einzelabrechnungen für jeden Eigentümer, erläutern diese in der Eigentümerversammlung und stehen für Rückfragen jederzeit zur Verfügung.',
  },
  {
    frage: 'In welchem Gebiet sind Sie tätig?',
    antwort:
      'Unser Schwerpunkt liegt in Magdeburg, Gerwisch und der näheren Umgebung. So können wir Objekte schnell erreichen und eine persönliche Betreuung vor Ort gewährleisten.',
  },
];

const Objekte = ({ onBack }) => {
  const [openFaq, setOpenFaq] = useState(0);

  const goToContact = () => {
    window.location.hash = '';
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-slate-50 py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={onBack}
          data-testid="objekte-back-button"
          className="mb-8 text-teal-600 hover:text-teal-700 hover:bg-teal-50"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        {/* Page Header with Hero Image */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-24">
          <div>
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Objekte & Verwaltung
            </span>
            <h1 className="text-3xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Was wir verwalten – und wie wir arbeiten
            </h1>
            <p className="text-lg text-slate-600">
              Von der Eigentumswohnung bis zur gemischt genutzten Immobilie: Wir betreuen
              unterschiedlichste Objekte in Magdeburg und Umgebung – persönlich, zuverlässig
              und mit über 20 Jahren Erfahrung.
            </p>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-teal-100 rounded-3xl -z-10 hidden lg:block" />
            <img
              src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=900&q=80"
              alt="Moderne Wohnanlage – Hausverwaltung"
              className="w-full h-[320px] lg:h-[420px] object-cover rounded-2xl shadow-xl"
              loading="lazy"
              data-testid="objekte-hero-image"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-5 hidden md:flex items-center gap-4 border border-slate-100">
              <div className="w-12 h-12 rounded-full bg-teal-600 flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900 leading-none">20+</p>
                <p className="text-sm text-slate-500">Jahre Erfahrung</p>
              </div>
            </div>
          </div>
        </div>

        {/* Section A: Objektarten */}
        <section className="mb-24" data-testid="objektarten-section">
          <div className="max-w-3xl mb-12">
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-3">
              Objektarten
            </span>
            <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-4">
              Diese Immobilien verwalten wir für Sie
            </h2>
            <p className="text-slate-600">
              Jede Immobilie ist anders – deshalb bieten wir für jede Objektart die passende
              Verwaltungsleistung. Ein Auszug aus unserem Leistungsspektrum:
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {objektarten.map((art, idx) => {
              const Icon = art.icon;
              return (
                <div
                  key={idx}
                  data-testid={`objektart-card-${idx}`}
                  className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-slate-100 group"
                >
                  <div className="w-14 h-14 rounded-xl bg-teal-50 flex items-center justify-center mb-5 group-hover:bg-teal-600 transition-colors duration-300">
                    <Icon className="w-7 h-7 text-teal-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">{art.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{art.description}</p>
                </div>
              );
            })}
          </div>
        </section>

        {/* Section C: Ablauf */}
        <section className="mb-24" data-testid="ablauf-section">
          {/* Banner image */}
          <div className="relative rounded-3xl overflow-hidden mb-12 h-[220px] md:h-[280px]">
            <img
              src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1600&q=80"
              alt="Beratungsgespräch zur Hausverwaltung"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
              data-testid="ablauf-banner-image"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/30" />
            <div className="relative h-full flex items-center px-8 md:px-12">
              <div className="max-w-xl">
                <span className="inline-block text-teal-300 font-semibold text-sm uppercase tracking-wider mb-3">
                  Ablauf
                </span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 leading-tight">
                  So läuft eine Verwaltungs&shy;übernahme ab
                </h2>
                <p className="text-slate-200 text-sm md:text-base">
                  Ein Verwalterwechsel muss nicht kompliziert sein – in fünf klaren
                  Schritten begleiten wir Sie.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            {/* Vertical line */}
            <div
              className="absolute left-7 top-4 bottom-4 w-0.5 bg-teal-200 hidden md:block"
              aria-hidden="true"
            />

            <div className="space-y-6">
              {ablaufSchritte.map((schritt, idx) => {
                const Icon = schritt.icon;
                return (
                  <div
                    key={idx}
                    data-testid={`ablauf-step-${idx}`}
                    className="relative flex gap-5 md:gap-8 items-start bg-white rounded-2xl p-6 md:p-7 shadow-sm border border-slate-100"
                  >
                    <div className="flex-shrink-0 relative z-10">
                      <div className="w-14 h-14 rounded-full bg-teal-600 text-white flex items-center justify-center shadow-lg shadow-teal-600/30">
                        <Icon className="w-6 h-6" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-baseline gap-3 mb-2 flex-wrap">
                        <span className="text-xs font-bold text-teal-600 uppercase tracking-wider">
                          Schritt {idx + 1}
                        </span>
                      </div>
                      <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">
                        {schritt.title}
                      </h3>
                      <p className="text-slate-600 text-sm md:text-base leading-relaxed">
                        {schritt.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Section D: FAQ */}
        <section className="mb-20" data-testid="faq-section">
          <div className="grid lg:grid-cols-[340px_1fr] gap-10 lg:gap-14">
            {/* Sidebar with heading + image */}
            <div className="lg:sticky lg:top-28 self-start">
              <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-3">
                Häufige Fragen
              </span>
              <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-4 leading-tight">
                Antworten für Eigentümer & Beiräte
              </h2>
              <p className="text-slate-600 mb-6">
                Die wichtigsten Fragen rund um Hausverwaltung, Verwalterwechsel und
                laufende Betreuung – kompakt beantwortet.
              </p>
              <div className="relative rounded-2xl overflow-hidden shadow-lg hidden md:block">
                <img
                  src="https://customer-assets.emergentagent.com/job_7886ce2f-0a69-4883-9ef3-edf923b4ae09/artifacts/uui3orn0_paul.jpg"
                  alt="Bärbel Paul – Inhaberin ADMIN Hausverwaltung"
                  className="w-full h-[260px] lg:h-[340px] object-cover object-top"
                  loading="lazy"
                  data-testid="faq-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/10 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <p className="text-sm font-semibold">Bärbel Paul</p>
                  <p className="text-xs text-slate-200">Inhaberin – persönliche Beratung</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
            {faqs.map((faq, idx) => {
              const isOpen = openFaq === idx;
              return (
                <div
                  key={idx}
                  data-testid={`faq-item-${idx}`}
                  className={`bg-white rounded-xl border transition-all duration-300 ${
                    isOpen ? 'border-teal-200 shadow-md' : 'border-slate-200 shadow-sm'
                  }`}
                >
                  <button
                    onClick={() => setOpenFaq(isOpen ? -1 : idx)}
                    data-testid={`faq-toggle-${idx}`}
                    className="w-full flex items-center justify-between gap-4 text-left p-5 md:p-6"
                    aria-expanded={isOpen}
                  >
                    <span className="font-semibold text-slate-900 text-base md:text-lg">
                      {faq.frage}
                    </span>
                    <ChevronDown
                      className={`w-5 h-5 flex-shrink-0 text-teal-600 transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-in-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 md:px-6 pb-6 text-slate-600 leading-relaxed">
                        {faq.antwort}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          </div>
        </section>

        {/* CTA Section */}
        <div
          className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 lg:p-12 text-center"
          data-testid="objekte-cta-section"
        >
          <h2 className="text-2xl lg:text-3xl font-bold text-white mb-4">
            Ihre Immobilie in guten Händen
          </h2>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">
            Sie überlegen, die Verwaltung Ihrer Immobilie in professionelle Hände zu geben?
            Wir beraten Sie gerne unverbindlich und erstellen Ihnen ein individuelles Angebot.
          </p>
          <Button
            onClick={goToContact}
            data-testid="objekte-contact-cta-button"
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 text-base font-semibold rounded-full transition-all duration-300 hover:scale-105"
          >
            Jetzt unverbindlich anfragen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Objekte;
